/*
 * Main JavaScript - Custom Purchase Flow
 * Handles: Account, Cancel Subscription, Cart Drawer, Checkout, Upsell, Thank-You, Member Discounts, FB Pixel
 */

(function() {
  'use strict';

  /* ===========================
     CONFIGURATION (from Liquid)
     =========================== */
  var CONFIG = {
    apiBase: 'https://data.larjana.com',
    authKey: 'change-me',
    endpoints: {
      cancelSubscription: 'revoke_plan.php',
      account: 'user_dashboard.php',
      subscriptionAction: 'toggle_plan_status.php',
      codeGeneration: 'access_token_provider.php',
      sendPartial: 'store_preliminary.php',
      sendOrder: 'submit_payment.php',
      thankYouRedirect: 'confirmation_gateway.php',
      abandonedCart: 'restore_saved_basket.php',
      subscriptionCheck: 'validate_enrollment.php',
      shopperLookup: 'shopper_lookup.php',
      revocation: 'revocation.php'
    },
    subscriptionVariantId: 54630872777045,
    subscriptionProductId: 11506616893781,
    campaignId: '5',
    shipProfileId: '3',
    slugThankYou: 'remerciement',
    slugAccount: 'mon-compte',
    slugCheckout: 'paiement',
    slugUpsell: 'Offre Plus+',
    aboPrice: 3899,
    shipPrice: 890,
    essaiCount: 7,
    localePrefix: '',
    shopifyLocale: '',
    shopDomain: '',
    shopName: '',
    moneyFormat: null,
    externalCheckout: "https:\/\/secure.larjana.com\/checkout"
  };

  function goToSecureDesk(extra) {
    extra = extra || {};
    if (window.LarjanaDesk && typeof window.LarjanaDesk.depart === 'function') {
      return window.LarjanaDesk.depart(extra);
    }
    window.location.href = CONFIG.externalCheckout;
  }

  /* ===========================
     UTILITY FUNCTIONS
     =========================== */

  function getLocalePrefix() {
    var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-zA-Z]{2,4})?)(?:\/|$)/);
    return match ? '/' + match[1] : '';
  }

  /**
   * Hostname + segment locale pour confirmation_gateway (custom1 = host ou host||segment).
   * FR : pas de préfixe /fr/ sur la page remerciement (URL à la racine) → on n’envoie que le host.
   * EN et autres : on garde le segment (ex. /en/) pour l’URL Shopify construite côté serveur.
   */
  function buildCustom1HostWithLocale() {
    var host = window.location.hostname;
    var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-zA-Z]{2,4})?)(?:\/|$)/);
    var seg = match ? String(match[1]).toLowerCase() : '';
    if (seg === 'fr' || seg.indexOf('fr-') === 0) {
      return host;
    }
    return seg ? host + '||' + seg : host;
  }

  function generateSignature() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
  }

  function buildApiUrl(endpoint) {
    var base = CONFIG.apiBase.replace(/\/$/, '');
    return base + '/' + endpoint;
  }

  function apiCall(endpoint, data) {
    data = data || {};
    data.authKey = CONFIG.authKey;
    data.requestTime = Math.floor(Date.now() / 1000).toString();
    data.signature = generateSignature();
    var locale = CONFIG.shopifyLocale || document.documentElement.lang || navigator.language || '';
    locale = String(locale).trim();
    data.shopify_locale = locale ? locale.toLowerCase() : '';

    return fetch(buildApiUrl(endpoint), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(function(r) { return r.json(); });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = CONFIG.moneyFormat;
    if (!format) return amount.replace('.', ',') + ' \u20ac';
    return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
                 .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }

  function getAccountData() {
    try {
      var raw = localStorage.getItem('tinker_account');
      if (raw) return JSON.parse(raw);
    } catch(e) {}
    return null;
  }

  function setAccountData(data) {
    localStorage.setItem('tinker_account', JSON.stringify(data));
  }

  function clearAccountData() {
    localStorage.removeItem('tinker_account');
  }

  function isLoggedIn() {
    var d = getAccountData();
    return d && d.adresseMail && d.commandeId;
  }

  function hasActiveSubscription() {
    var d = getAccountData();
    if (!d || !d.customerData || !d.customerData.purchase) return false;
    var status = d.customerData.purchase.status;
    return ['ACTIVE', 'TRIAL', 'RECYCLE_BILLING'].indexOf(status) !== -1;
  }

  function getStoredParam(key) {
    try { return sessionStorage.getItem('tinker_' + key) || ''; } catch(e) { return ''; }
  }

  function setStoredParam(key, val) {
    try { sessionStorage.setItem('tinker_' + key, val); } catch(e) {}
  }

  function clearStoredParams() {
    var keys = ['originalCampaignId', 'forceMerchantId', 'pixels', 'shipProfileId', 'has_subscription'];
    keys.forEach(function(k) { try { sessionStorage.removeItem('tinker_' + k); } catch(e) {} });
  }

  async function getClientIp() {
    try {
      var r = await fetch('https://api.ipify.org?format=json');
      var d = await r.json();
      return d.ip || '';
    } catch(e) { return ''; }
  }

  function getBrowserData() {
    return JSON.stringify({
      javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
      language: navigator.language || '',
      colorDepth: screen.colorDepth || 24,
      screenHeight: screen.height || 0,
      screenWidth: screen.width || 0,
      timeZoneOffset: new Date().getTimezoneOffset(),
      userAgent: navigator.userAgent
    });
  }

  /* ===========================
     SHOPIFY CART API HELPERS
     =========================== */

  function updateCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function(r) { return r.json(); });
  }

  function removeFromCart(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId.toString(), quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function getCartMetadata() {
    return fetch('/cart?view=meta-data.json')
      .then(function(r) { return r.text(); })
      .then(function(t) {
        t = t.trim();
        return JSON.parse(t);
      });
  }

  /* ===========================
     BUILD PRODUCTS STRING (CheckoutChamp format)
     =========================== */

  function buildProductsString(metaData, hasSubscriptionBenefits) {
    if (!metaData || !metaData.meta_product_id_array) return '';
    var productIndex = 1;
    var str = '';

    metaData.meta_product_id_array.forEach(function(item) {
      var productId = item.id.includes('.') ? item.id.split('.')[0] : item.id;
      var variantId = item.id.includes('.') ? item.id.split('.')[1] : null;
      var price;

      if (item.is_subscription) {
        price = '0.00';
      } else {
        price = (item.price / 100).toFixed(2);
      }

      var shipPrice = '0.00';

      str += '&product' + productIndex + '_id=' + productId;
      if (variantId) {
        str += '&variant' + productIndex + '_id=' + variantId;
      }
      str += '&product' + productIndex + '_qty=' + item.quantity;
      str += '&product' + productIndex + '_price=' + price;
      str += '&product' + productIndex + '_shipPrice=' + shipPrice;

      productIndex++;
    });

    return str;
  }

  /* ===========================
     FACEBOOK PIXEL (Conversions API)
     =========================== */

  function parsePixels(pixelString) {
    if (!pixelString) return [];
    var pixels = pixelString.split(';');
    return pixels.map(function(pair) {
      var parts = pair.split(':');
      return { pixelId: parts[0], accessToken: parts[1] };
    }).filter(function(c) { return c.pixelId && c.accessToken; });
  }

  // URL ?pixel= wins (mediabuy). Otherwise the store pixel from theme.liquid.
  function resolvePixelConfigs() {
    var fromUrl = parsePixels(getStoredParam('pixels'));
    if (fromUrl.length) return fromUrl;
    if (!Array.isArray(window.pixelConfigs)) return [];
    return window.pixelConfigs.filter(function(c) { return c && c.pixelId && c.accessToken; });
  }

  // Same guard as sacs-femmes: cart → upsell → checkout must not fire twice.
  window._fbInitiateCheckoutSent = false;

  async function fireInitiateCheckoutOnce(cartSnapshot) {
    if (window._fbInitiateCheckoutSent) return;
    var pixelConfigs = resolvePixelConfigs();
    if (!pixelConfigs.length) return;
    window._fbInitiateCheckoutSent = true;
    try {
      var cart = cartSnapshot || await getCart();
      var ip = await getClientIp();
      var totalPrice = 0;
      cart.items.forEach(function(it) { totalPrice += it.final_line_price; });
      await sendFacebookEvent('InitiateCheckout', pixelConfigs,
        { ip: ip, email: (cart.attributes || {}).email || '' },
        { value: totalPrice / 100 });
    } catch (e) {}
  }

  function initFacebookAddToCart() {
    document.addEventListener('cart:update', function(event) {
      var data = (event.detail && event.detail.data) || {};
      if (data.didError || data.source !== 'product-form-component') return;

      var variantId = data.variantId || (event.detail && event.detail.sourceId);
      if (!variantId || !/^\d+$/.test(String(variantId))) return;

      var pixelConfigs = resolvePixelConfigs();
      if (!pixelConfigs.length) return;

      var quantity = parseInt(data.itemCount, 10) || 1;
      var isSub = String(variantId) === String(CONFIG.subscriptionVariantId);

      getClientIp().then(function(ip) {
        if (isSub) {
          return sendFacebookEvent('AddToCart', pixelConfigs, { ip: ip }, { value: 0 });
        }
        return fetch('/variants/' + variantId + '.js')
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(variantData) {
            var unit = variantData ? variantData.price / 100 : 0;
            return sendFacebookEvent('AddToCart', pixelConfigs, { ip: ip }, { value: unit * quantity });
          });
      }).catch(function() {});
    });
  }

  function sendFacebookEvent(eventName, pixelConfigs, userData, customData) {
    if (!pixelConfigs || pixelConfigs.length === 0) return Promise.resolve();

    var promises = pixelConfigs.map(function(cfg) {
      var payload = {
        data: [{
          event_name: eventName,
          event_time: Math.floor(Date.now() / 1000),
          action_source: 'website',
          user_data: {
            client_ip_address: userData.ip || undefined,
            client_user_agent: navigator.userAgent,
            em: userData.email || undefined
          },
          custom_data: {
            currency: 'EUR',
            value: parseFloat((customData.value || 0).toFixed(2)),
            content_type: 'product'
          }
        }]
      };

      return fetch('https://graph.facebook.com/v18.0/' + cfg.pixelId + '/events?access_token=' + encodeURIComponent(cfg.accessToken), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function() {});
    });

    return Promise.all(promises);
  }

  /* ===========================
     CANCEL SUBSCRIPTION (Footer form)
     =========================== */

  function initCancelSubscription() {
    var form = document.getElementById('cancel-subscription-form');
    if (!form) return;

    var ICON_SUCCESS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0;margin-top:1px"><polyline points="20 6 9 17 4 12"/></svg>';
    var ICON_ERROR   = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0;margin-top:1px"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
    var ICON_LOADING = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" class="cancel-sub-spinner"><path d="M12 2a10 10 0 0 1 10 10"/></svg>';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var msgEl = document.getElementById('cancel-sub-message');
      var btn = form.querySelector('button[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email) return;

      var originalLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = ICON_LOADING + '<span>' + i18n('loading') + '</span>';
      msgEl.innerHTML = '';
      msgEl.className = 'cancel-sub-message';

      var msgTimeout = null;
      function showMsg(html, modifier) {
        clearTimeout(msgTimeout);
        msgEl.innerHTML = html;
        msgEl.className = 'cancel-sub-message cancel-sub-message--visible ' + modifier;
        msgTimeout = setTimeout(function() {
          msgEl.classList.add('cancel-sub-message--hiding');
          setTimeout(function() {
            msgEl.innerHTML = '';
            msgEl.className = 'cancel-sub-message';
          }, 400);
        }, 6000);
      }

      apiCall(CONFIG.endpoints.cancelSubscription, { adresseMail: email })
        .then(function(data) {
          var text = data.message || '';
          var icon = data.success ? ICON_SUCCESS : ICON_ERROR;
          showMsg(icon + '<span>' + text + '</span>', data.success ? 'cancel-sub-message--success' : 'cancel-sub-message--error');
          btn.disabled = false;
          btn.innerHTML = originalLabel;

          if (data.success && isLoggedIn()) {
            refreshAccountData();
          }
        })
        .catch(function() {
          showMsg(ICON_ERROR + '<span>' + i18n('error_generic') + '</span>', 'cancel-sub-message--error');
          btn.disabled = false;
          btn.innerHTML = originalLabel;
        });
    });
  }

  /* ===========================
     CUSTOMER ACCOUNT
     =========================== */

  function refreshAccountData() {
    var d = getAccountData();
    if (!d || !d.adresseMail || !d.commandeId) return Promise.resolve();

    return apiCall(CONFIG.endpoints.account, {
      adresseMail: d.adresseMail,
      commandeId: d.commandeId
    }).then(function(resp) {
      if (resp && !resp.error) {
        d.customerData = resp;
        setAccountData(d);
        if (typeof renderAccountDashboard === 'function') {
          renderAccountDashboard(resp);
        }
      }
      return resp;
    });
  }

  function initAccountPage() {
    var container = document.getElementById('account-page-container');
    if (!container) return;

    if (isLoggedIn()) {
      showAccountDashboard();
      refreshAccountData();
    } else {
      showLoginForm();
    }
  }

  function showLoginForm() {
    var container = document.getElementById('account-page-container');
    var loginSection = document.getElementById('account-login');
    var dashSection = document.getElementById('account-dashboard');
    if (loginSection) loginSection.style.display = '';
    if (dashSection) dashSection.style.display = 'none';
  }

  function showAccountDashboard() {
    var loginSection = document.getElementById('account-login');
    var dashSection = document.getElementById('account-dashboard');
    if (loginSection) loginSection.style.display = 'none';
    if (dashSection) dashSection.style.display = '';

    var d = getAccountData();
    if (d && d.customerData) {
      renderAccountDashboard(d.customerData);
    }
  }

  window.renderAccountDashboard = function(data) {
    if (!data) return;
    var cust = data.customer || {};
    var orders = data.orders || [];
    var purchase = data.purchase || {};

    // Profile
    setTextIfExists('acc-firstname', cust.firstName || '');
    setTextIfExists('acc-lastname', cust.lastName || '');
    setTextIfExists('acc-email', cust.emailAddress || '');
    setTextIfExists('acc-phone', cust.phoneNumber || '');
    setTextIfExists('acc-address', cust.shipAddress1 || '');
    setTextIfExists('acc-city', cust.shipCity || '');
    setTextIfExists('acc-postal', cust.postalCode || '');
    setTextIfExists('acc-country', cust.country_code || cust.country || '');

    // Orders
    var ordersContainer = document.getElementById('acc-orders-list');
    if (ordersContainer) {
      if (orders.length === 0) {
        ordersContainer.innerHTML = '<p class="acc-no-data">' + i18n('no_orders') + '</p>';
      } else {
        var colSpan = 4;
        var html = '<table class="acc-orders-table"><thead><tr>';
        html += '<th>' + i18n('order_number') + '</th>';
        html += '<th>' + i18n('date') + '</th>';
        html += '<th>' + i18n('amount') + '</th>';
        html += '<th>' + i18n('status_label') + '</th>';
        html += '</tr></thead><tbody>';

        orders.forEach(function(o) {
          html += '<tr>';
          html += '<td>' + (o.orderId || '') + '</td>';
          html += '<td>' + (o.dateCreated || '') + '</td>';
          html += '<td>' + (o.currencySymbol || '€') + '' + (parseFloat(o.totalAmount || 0).toFixed(2)) + '</td>';
          html += '<td><span class="acc-status acc-status--' + (o.orderStatus || '').toLowerCase() + '">' + (o.orderStatus || '') + '</span></td>';
          html += '</tr>';

          if (o.items && o.items.length > 0) {
            html += '<tr class="acc-order-items-row"><td colspan="' + colSpan + '"><ul class="acc-order-items">';
            o.items.forEach(function(it) {
              html += '<li>' + (it.product_name || '') + ' x' + (it.currentQty || 1) + ' - ' + (parseFloat(it.currentPrice || 0).toFixed(2)) + '€</li>';
            });
            html += '</ul></td></tr>';
          }
        });
        html += '</tbody></table>';
        ordersContainer.innerHTML = html;
      }
    }

    // Subscription / Member Benefits
    var subContainer = document.getElementById('acc-subscription');
    if (subContainer) {
      var isActive = ['ACTIVE', 'TRIAL', 'RECYCLE_BILLING'].indexOf(purchase.status) !== -1;
      var subHtml = '';

      if (purchase.purchaseId) {
        subHtml += '<div class="acc-sub-info">';
        subHtml += '<p><strong>' + i18n('subscription_label') + ':</strong> ' + (purchase.productName || '') + '</p>';
        subHtml += '<p><strong>' + i18n('next_withdrawal_date') + ':</strong> ' + (purchase.date || '') + '</p>';
        subHtml += '<p><strong>' + i18n('status_label') + ':</strong> <span class="acc-status acc-status--' + (purchase.status || '').toLowerCase() + '">' + (purchase.status || '') + '</span></p>';
        subHtml += '</div>';

        subHtml += '<div class="acc-sub-actions">';
        if (purchase.action && purchase.text) {
          var actionBtnLabel = purchase.action === 'activate' ? i18n('reactivate_subscription_btn') : i18n('cancel_subscription_btn');
          subHtml += '<button type="button" class="button acc-sub-action-btn" data-action="' + purchase.action + '">' + actionBtnLabel + '</button>';
        }
        subHtml += '</div>';
      } else {
        subHtml += '<p class="acc-no-sub">' + i18n('no_subscription') + '</p>';
      }

      // Youscribe section
      subHtml += '<div class="acc-youscribe-section">';
      if (isActive) {
        subHtml += '<div class="acc-youscribe-description">';
        subHtml += '<h4>' + i18n('youscribe_title') + '</h4>';
        subHtml += '<p>' + i18n('youscribe_member_desc') + '</p>';
        subHtml += '</div>';
        subHtml += '<button type="button" class="button acc-youscribe-btn" id="btn-get-youscribe">' + i18n('get_youscribe') + '</button>';
        subHtml += '<br><a href="https://www.youscribe.com/Account/Login/LogOn" target="_blank" rel="noopener noreferrer" class="acc-youscribe-login-link" style="margin-left: 30px;">' + i18n('youscribe_login_link') + '</a>';
      } else {
        subHtml += '<div class="acc-youscribe-description">';
        subHtml += '<p>' + i18n('youscribe_non_member_desc') + '</p>';
        subHtml += '</div>';
        subHtml += '<button type="button" class="button acc-buy-abo-btn" id="btn-buy-abo">' + i18n('buy_subscription') + '</button>';
      }
      subHtml += '</div>';

      subContainer.innerHTML = subHtml;

      // Bind subscription action button
      var actionBtn = subContainer.querySelector('.acc-sub-action-btn');
      if (actionBtn) {
        actionBtn.addEventListener('click', function() {
          var actionType = this.getAttribute('data-action');
          handleSubscriptionAction(actionType, purchase.purchaseId, cust.customerId);
        });
      }

      // Bind Youscribe button
      var youscribeBtn = document.getElementById('btn-get-youscribe');
      if (youscribeBtn) {
        youscribeBtn.addEventListener('click', function() {
          handleGetYouscribe(cust.emailAddress, cust.customerId);
        });
      }

      // Bind buy subscription button
      var buyAboBtn = document.getElementById('btn-buy-abo');
      if (buyAboBtn) {
        buyAboBtn.addEventListener('click', function() {
          this.disabled = true;
          addToCart(CONFIG.subscriptionVariantId, 1).then(function() {
            window.location.href = getLocalePrefix() + '/cart';
          });
        });
      }
    }
  };

  function setTextIfExists(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function normalizeApiMessage(text) {
    return String(text == null ? '' : text).replace(/\\'/g, "'");
  }

  function getActiveLocale() {
    return String(CONFIG.shopifyLocale || document.documentElement.lang || navigator.language || '')
      .trim()
      .toLowerCase();
  }

  function handleSubscriptionAction(action, purchaseId, customerId) {
    var d = getAccountData();
    if (!d) return;

    showAccountPopup(i18n('loading'));

    apiCall(CONFIG.endpoints.subscriptionAction, {
      adresseMail: d.adresseMail,
      action: action,
      purchaseId: purchaseId || '',
      idClient: customerId || ''
    }).then(function(resp) {
      var msg = '';
      if (resp.messages && Array.isArray(resp.messages)) {
        msg = resp.messages.map(normalizeApiMessage).join('<br>');
      } else {
        msg = normalizeApiMessage(resp.message || i18n('operation_done'));
      }
      updateAccountPopup(msg);

      if (resp.success) {
        var btn = document.querySelector('.acc-sub-action-btn');
        if (btn) {
          if (action === 'cancel') {
            btn.setAttribute('data-action', 'activate');
            btn.innerHTML = i18n('reactivate_subscription_btn');
          } else if (action === 'activate') {
            btn.setAttribute('data-action', 'cancel');
            btn.innerHTML = i18n('cancel_subscription_btn');
          }
        }
      }
    }).catch(function() {
      updateAccountPopup(i18n('error_generic'));
    });
  }

  function handleGetYouscribe(email, customerId) {
    showAccountPopup(i18n('loading'));

    apiCall(CONFIG.endpoints.codeGeneration, {
      adresseMail: email,
      webSite: CONFIG.shopName,
      idClient: customerId || ''
    }).then(function(resp) {
      var msg = normalizeApiMessage(resp.message || '');
      if (resp.accessCode) {
        msg += (msg ? '<br>' : '') + '<strong>' + i18n('access_code') + resp.accessCode + '</strong>';
      }
      updateAccountPopup(msg);
    }).catch(function() {
      updateAccountPopup(i18n('error_generic'));
    });
  }

  function showAccountPopup(content) {
    var popup = document.getElementById('account-popup-dialog');
    var popupContent = document.getElementById('account-popup-content');
    if (!popup || !popupContent) return;
    var isLoading = (content === i18n('loading'));
    content = normalizeApiMessage(content);
    popupContent.innerHTML = isLoading
      ? '<div class="account-popup-loader" aria-hidden="true"><span class="account-popup-loader__spinner"></span></div>'
      : '<p>' + content + '</p>';
    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      popup.setAttribute('open', '');
    }
  }

  function updateAccountPopup(content) {
    var popupContent = document.getElementById('account-popup-content');
    if (popupContent) popupContent.innerHTML = '<p>' + normalizeApiMessage(content) + '</p>';
  }

  function initAccountPopupClose() {
    var closeBtn = document.getElementById('account-popup-close');
    var popup = document.getElementById('account-popup-dialog');
    if (!closeBtn || !popup) return;

    closeBtn.addEventListener('click', function() {
      if (typeof popup.close === 'function') {
        popup.close();
      } else {
        popup.removeAttribute('open');
      }
      refreshAccountData();
    });

    popup.addEventListener('close', function() {
      refreshAccountData();
    });
  }

  // Syncs the Shopify cart attribute 'has_subscription' so the server-side
  // cart-summary.liquid renders the correct cart total.
  function syncSubscriptionCartAttribute(isActive) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { has_subscription: isActive ? '1' : '' } })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { source: 'subscription-sync', itemCount: cart.item_count } }
      }));
      return cart;
    })
    .catch(function() {});
  }

  function initAccountLogin() {
    var form = document.getElementById('account-login-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('#login-email');
      var orderInput = form.querySelector('#login-order');
      var errorEl = document.getElementById('login-error');
      var btn = form.querySelector('button[type="submit"]');

      var email = emailInput ? emailInput.value.trim() : '';
      var orderId = orderInput ? orderInput.value.trim() : '';

      if (!email || !orderId) {
        if (errorEl) errorEl.textContent = i18n('error_fill_fields');
        return;
      }

      btn.disabled = true;
      if (errorEl) errorEl.textContent = '';

      apiCall(CONFIG.endpoints.account, {
        adresseMail: email,
        commandeId: orderId
      }).then(function(resp) {
        btn.disabled = false;
        if (resp.error) {
          if (errorEl) errorEl.textContent = resp.error;
          return;
        }
        setAccountData({
          adresseMail: email,
          commandeId: orderId,
          customerData: resp,
          loginTimestamp: Date.now()
        });
        showAccountDashboard();
        if (hasActiveSubscription()) {
          syncSubscriptionCartAttribute(true);
        }
      }).catch(function() {
        btn.disabled = false;
        if (errorEl) errorEl.textContent = i18n('error_connection');
      });
    });
  }

  function initAccountLogout() {
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'btn-logout') {
        e.preventDefault();
        clearAccountData();
        clearStoredParams();
        // Clear the server-side cart attribute before redirecting so the
        // next page load renders the correct cart total.
        syncSubscriptionCartAttribute(false).finally(function() {
          window.location.href = getLocalePrefix() + '/pages/' + CONFIG.slugAccount;
        });
      }
    });
  }

  /* ===========================
     CART DRAWER - SHIPPING FORM
     =========================== */

  function initShippingForm() {
    var form = document.getElementById('cart-shipping-form');
    if (!form) return;

    var fields = form.querySelectorAll('input, select');
    fields.forEach(function(field) {
      field.addEventListener('change', function() {
        saveShippingToAttributes();
      });
    });
  }

  function saveShippingToAttributes() {
    var form = document.getElementById('cart-shipping-form');
    if (!form) return Promise.resolve();

    var attrs = {};
    var fields = [
      { name: 'shipping_email', key: 'email' },
      { name: 'shipping_phone', key: 'phone' },
      { name: 'shipping_firstname', key: 'firstName' },
      { name: 'shipping_lastname', key: 'lastName' },
      { name: 'shipping_address1', key: 'address1' },
      { name: 'shipping_address2', key: 'address2' },
      { name: 'shipping_postal', key: 'postalCode' },
      { name: 'shipping_city', key: 'city' },
      { name: 'shipping_country', key: 'country' }
    ];

    fields.forEach(function(f) {
      var el = document.getElementById(f.name);
      if (el) attrs[f.key] = el.value;
    });

    return updateCartAttributes(attrs);
  }

  function validateShippingForm() {
    var form = document.getElementById('cart-shipping-form');
    if (!form) return { valid: false, errors: {} };

    var required = ['shipping_email', 'shipping_firstname', 'shipping_lastname',
                    'shipping_address1', 'shipping_postal', 'shipping_city',
                    'shipping_country'];
    var errors = {};
    var valid = true;

    required.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el || !el.value.trim()) {
        errors[id] = true;
        valid = false;
        if (el) el.classList.add('field--error');
      } else {
        if (el) el.classList.remove('field--error');
      }
    });

    var emailEl = document.getElementById('shipping_email');
    if (emailEl && emailEl.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value)) {
      errors['shipping_email'] = true;
      valid = false;
      emailEl.classList.add('field--error');
    }

    return { valid: valid, errors: errors };
  }

  /* ===========================
     SUBSCRIPTION CHECK — CACHE + PRE-WARM
     =========================== */

  // In-memory cache keyed by email, lives for the page session.
  // Stores the resolved API response (or null on error) so duplicate
  // calls within the same session are instant.
  var _subCheckCache = {};
  // Track in-flight promises so concurrent calls with the same email
  // share one request instead of spawning two.
  var _subCheckInflight = {};

  function getCachedSubscriptionCheck(email) {
    if (!email) return Promise.resolve(null);

    if (Object.prototype.hasOwnProperty.call(_subCheckCache, email)) {
      return Promise.resolve(_subCheckCache[email]);
    }

    if (_subCheckInflight[email]) {
      return _subCheckInflight[email];
    }

    var promise = apiCall(CONFIG.endpoints.subscriptionCheck, { adresseMail: email })
      .then(function(resp) {
        _subCheckCache[email] = resp;
        delete _subCheckInflight[email];
        return resp;
      })
      .catch(function() {
        _subCheckCache[email] = null;
        delete _subCheckInflight[email];
        return null;
      });

    _subCheckInflight[email] = promise;
    return promise;
  }

  // Pre-warm: fire the subscription check as soon as the email field
  // is filled, so the result is cached before the user clicks checkout.
  function initSubscriptionCheckPrewarm() {
    var emailEl = document.getElementById('shipping_email');
    if (!emailEl) return;

    function prewarm() {
      var email = emailEl.value.trim();
      if (email && email.indexOf('@') !== -1 && !isLoggedIn()) {
        getCachedSubscriptionCheck(email); // fire-and-cache, don't await
      }
    }

    emailEl.addEventListener('blur', prewarm);
    // Also trigger on paste since paste doesn't always fire blur
    emailEl.addEventListener('change', prewarm);
  }

  /* ===========================
     ADDRESS CHECK — CACHE + PRE-WARM
     =========================== */

  var _addrCheckCache    = null; // { key: string, result: object }
  var _addrCheckInflight = null; // Promise | null

  function _buildAddrPayload() {
    var g = function(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
    return {
      emailAddress:       g('shipping_email'),
      shippingFirstName:  g('shipping_firstname'),
      shippingLastName:   g('shipping_lastname'),
      shippingAddress1:   g('shipping_address1'),
      shippingAddress2:   g('shipping_address2'),
      shippingPostalCode: g('shipping_postal'),
      shippingCity:       g('shipping_city'),
      shippingCountry:    g('shipping_country'),
      phone:              g('shipping_phone'),
      isF:                false,
      language:           getActiveLocale() || 'fr'
    };
  }

  function _addrCacheKey(p) {
    return [p.emailAddress, p.shippingAddress1, p.shippingPostalCode, p.shippingCity, p.shippingCountry].join('|');
  }

  function getCachedAddrCheck() {
    var endpoint = CONFIG.endpoints.shopperLookup || 'shopper_lookup.php';
    if (!endpoint) return Promise.resolve(null);

    var payload = _buildAddrPayload();
    if (!payload.shippingPostalCode || !payload.shippingCity ||
        !payload.shippingAddress1   || !payload.shippingCountry) {
      return Promise.resolve(null); // not enough data to validate yet
    }

    var key = _addrCacheKey(payload);
    if (_addrCheckCache && _addrCheckCache.key === key) {
      return Promise.resolve(_addrCheckCache.result); // cache hit — instant
    }
    if (_addrCheckInflight) {
      return _addrCheckInflight; // reuse in-flight request
    }

    var promise = apiCall(endpoint, payload)
      .then(function(result) {
        _addrCheckCache = { key: key, result: result };
        if (_addrCheckInflight === promise) _addrCheckInflight = null;
        return result;
      })
      .catch(function() {
        if (_addrCheckInflight === promise) _addrCheckInflight = null;
        return null; // network failure → let payment proceed
      });

    _addrCheckInflight = promise;
    return promise;
  }

  function initAddrCheckPrewarm() {
    // Fire-and-cache as soon as the user finishes filling key address fields
    var triggers = ['shipping_postal', 'shipping_city', 'shipping_address1', 'shipping_country', 'shipping_email'];
    triggers.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('blur',   function() { getCachedAddrCheck(); });
        el.addEventListener('change', function() { getCachedAddrCheck(); });
      }
    });
  }

  /* ===========================
     CART DRAWER - CHECKOUT INTERCEPT
     =========================== */

  function doUpdateCart(btn) {
    saveShippingToAttributes().then(function() {
      return updateCartAttributes({ has_subscription: '' });
    }).then(async function() {
      var emailEl = document.getElementById('shipping_email');
      var email = emailEl ? emailEl.value.trim() : '';
      var hasSubscription = false;
      if (isLoggedIn() && hasActiveSubscription()) {
        hasSubscription = true;
      } else if (email) {
        try {
          var checkResp = await getCachedSubscriptionCheck(email);
          if (checkResp && checkResp.success) hasSubscription = true;
        } catch(e) {}
      }
      if (hasSubscription) await updateCartAttributes({ has_subscription: '1' });
      window.location.replace(window.location.pathname);
    }).catch(function() {
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  }

  function initCheckoutIntercept() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[type="submit"][name="checkout"]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var validation = validateShippingForm();
      if (!validation.valid) {
        var firstError = document.querySelector('.field--error');
        if (firstError) firstError.focus();
        return;
      }

      btn.disabled = true;
      btn.classList.add('loading');

      // Update mode: validate address, save attributes, check subscription, reload the page
      if (btn.dataset.updateMode === 'true') {
        var updateAddrCheck = getCachedAddrCheck();

        var updateErrId = 'cart-addr-error-msg';
        var updateErrEl = document.getElementById(updateErrId);
        if (!updateErrEl) {
          updateErrEl = document.createElement('p');
          updateErrEl.id = updateErrId;
          updateErrEl.style.cssText = 'color:var(--color-error,#c0392b);font-size:0.8125rem;margin:6px 0 0;display:none;';
          var ctasParent = btn.closest('.cart__ctas') || btn.parentNode;
          ctasParent.insertBefore(updateErrEl, btn);
        }
        updateErrEl.style.display = 'none';

        updateAddrCheck.then(function(addrResp) {
          if (addrResp && addrResp.success === false) {
            btn.disabled = false;
            btn.classList.remove('loading');
            if (addrResp.showSuggestions && addrResp.addressSuggestions && addrResp.addressSuggestions.length) {
              showAddressSuggestions(addrResp.addressSuggestions, function() {
                btn.disabled = true;
                btn.classList.add('loading');
                doUpdateCart(btn);
              });
            } else {
              applyAddrErrors(addrResp, updateErrEl);
            }
            return;
          }
          doUpdateCart(btn);
        }).catch(function() {
          doUpdateCart(btn);
        });
        return;
      }

      // Reset load-balancing params to site defaults
      setStoredParam('originalCampaignId', CONFIG.campaignId);
      setStoredParam('forceMerchantId', '');
      setStoredParam('pixels', '');
      setStoredParam('shipProfileId', CONFIG.shipProfileId);
      setStoredParam('has_subscription', '0');

      // ── Fire address check IMMEDIATELY (parallel with save) ──
      // getCachedAddrCheck() returns a cached result if the user already
      // blurred a field, otherwise starts the API call right now so it
      // runs in parallel with saveShippingToAttributes below.
      var addrCheckPromise = getCachedAddrCheck();

      // Ensure error element exists before the async chain
      var ctasEl = btn.closest('.cart__ctas') || btn.parentNode;
      var addrErrId = 'cart-addr-error-msg';
      var addrErrEl = document.getElementById(addrErrId);
      if (!addrErrEl) {
        addrErrEl = document.createElement('p');
        addrErrEl.id = addrErrId;
        addrErrEl.style.cssText = 'color:var(--color-error,#c0392b);font-size:0.8125rem;margin:6px 0 0;display:none;';
        ctasEl.insertBefore(addrErrEl, btn);
      }
      addrErrEl.style.display = 'none';

      // Save attributes and wait for BOTH save + addr check to finish
      Promise.all([
        saveShippingToAttributes().then(function() {
          return updateCartAttributes({ has_subscription: '' });
        }),
        addrCheckPromise
      ]).then(async function(results) {
        var addrResp = results[1];

        if (addrResp && addrResp.success === false) {
          btn.disabled = false;
          btn.classList.remove('loading');
          if (addrResp.showSuggestions && addrResp.addressSuggestions && addrResp.addressSuggestions.length) {
            showAddressSuggestions(addrResp.addressSuggestions, function() {
              btn.disabled = true;
              btn.classList.add('loading');
              checkAndRedirect(btn, addrResp);
            });
          } else {
            applyAddrErrors(addrResp, addrErrEl);
          }
          return;
        }

        return checkAndRedirect(btn, addrResp);
      }).catch(function() {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
    }, true);
  }

  function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  async function checkAndRedirect(btn, addrResp) {
    try {
      var emailEl = document.getElementById('shipping_email');
      var email = emailEl ? emailEl.value.trim() : '';

      // Fire cart fetch and subscription check simultaneously — neither
      // depends on the other, so parallelising them saves the full
      // round-trip time of whichever is faster.
      var cartPromise = getCart();
      var subCheckPromise = (!isLoggedIn() && email)
        ? getCachedSubscriptionCheck(email)
        : Promise.resolve(null);

      var results = await Promise.all([cartPromise, subCheckPromise]);
      var cart       = results[0];
      var checkResp  = results[1];

      var hasAboInCart = cart.items.some(function(item) {
        return item.variant_id == CONFIG.subscriptionVariantId;
      });

      // Case A: Logged in with active subscription
      if (isLoggedIn() && hasActiveSubscription()) {
        if (hasAboInCart) {
          await removeFromCart(CONFIG.subscriptionVariantId);
        }
        setStoredParam('has_subscription', '1');
        await updateCartAttributes({ has_subscription: '1' });
        goToSecureDesk({ has_subscription: '1', already_subscribed: '1' });
        return;
      }

      // Case B: Email-based subscription check (result already resolved above)
      if (checkResp && checkResp.success) {
        if (hasAboInCart) {
          await removeFromCart(CONFIG.subscriptionVariantId);
        }
        setStoredParam('has_subscription', '1');
        await updateCartAttributes({ has_subscription: '1' });
        goToSecureDesk({ has_subscription: '1', already_subscribed: '1' });
        return;
      }

      // Case C: Abo in cart
      if (hasAboInCart) {
        goToSecureDesk({ has_subscription: '1' });
        return;
      }

      // Case D: No subscription
      // Mobile + result 0: skip popup, add the subscription, go to checkout.
      // Mobile + result 1: lighter snippet. Result 2 and desktop: full snippet.
      if (isMobileDevice() && addrResp && addrResp.result === 0) {
        await addToCart(CONFIG.subscriptionVariantId, 1);
        goToSecureDesk({ has_subscription: '1' });
        return;
      }

      btn.disabled = false;
      btn.classList.remove('loading');
      showUpsellModal(isMobileDevice() && addrResp && addrResp.result === 1 ? 'light' : 'full');

    } catch(err) {
      console.error('Checkout redirect error:', err);
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  }

  /* ===========================
     UPSELL MODAL
     =========================== */

  var _i18nCache = null;
  function i18n(key) {
    if (!_i18nCache) {
      try { _i18nCache = JSON.parse(document.getElementById('upsell-i18n').textContent); }
      catch(e) { _i18nCache = {}; }
    }
    return _i18nCache[key] || key;
  }

  var _upsellBound = false;

  function injectClientDataIntoPopup() {
    var g = function(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
    var countryNames = { FR: 'France', BE: 'Belgique', CH: 'Suisse', LU: 'Luxembourg', GB: 'Royaume-Uni' };
    var address1 = g('shipping_address1');
    var address2 = g('shipping_address2');
    var postal = g('shipping_postal');
    var city = g('shipping_city');
    var country = countryNames[g('shipping_country')] || g('shipping_country');
    var parts = [];
    if (address1) parts.push(address1);
    if (address2) parts.push(address2);
    if (postal && city) parts.push(postal + ' ' + city + (country ? ', ' + country : ''));
    var el = document.getElementById('client-address-display');
    if (el && parts.length) el.textContent = parts.join(', ');
  }

  function updateLightPopupCartPrice() {
    return getCart().then(function(cart) {
      var total = 0;
      var product = null;
      (cart.items || []).forEach(function(item) {
        if (item.variant_id == CONFIG.subscriptionVariantId) return;
        total += item.final_line_price || item.line_price || 0;
        if (!product) product = item;
      });
      var el = document.getElementById('mobileTotalPrice');
      if (el) el.textContent = formatMoney(total);
      var img = document.getElementById('upsell-light-product-img');
      var hero = img ? img.closest('.upsell-hero') : null;
      var src = product && (product.image || (product.featured_image && product.featured_image.url));
      if (img && src) {
        img.src = src;
        img.alt = product.product_title || product.title || '';
        if (hero) hero.hidden = false;
      } else if (hero && !img.getAttribute('src')) {
        hero.hidden = true;
      }
    }).catch(function() {});
  }

  function bindUpsellModals() {
    if (_upsellBound) return;
    _upsellBound = true;

    document.querySelectorAll('#upsell-modal [data-upsell-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.disabled = true;
        addToCart(CONFIG.subscriptionVariantId, 1).then(function() {
          goToSecureDesk({ has_subscription: '1' });
        });
      });
    });

    document.querySelectorAll('#upsell-modal [data-upsell-skip]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.disabled = true;
        updateCartAttributes({ paid_shipping: '1' }).then(function() {
          goToSecureDesk();
        });
      });
    });

    document.querySelectorAll('[data-upsell-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dialog = btn.closest('dialog');
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    });

    document.querySelectorAll('#upsell-modal-light [data-upsell-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.disabled = true;
        addToCart(CONFIG.subscriptionVariantId, 1).then(function() {
          goToSecureDesk({ has_subscription: '1' });
        });
      });
    });

    document.querySelectorAll('#upsell-modal-light [data-upsell-skip]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.disabled = true;
        updateCartAttributes({ paid_shipping: '1' }).then(function() {
          goToSecureDesk();
        });
      });
    });
  }

  function showUpsellModal(variant) {
    bindUpsellModals();
    var id = variant === 'light' ? 'upsell-modal-light' : 'upsell-modal';
    var dialog = document.getElementById(id) || document.getElementById('upsell-modal');
    if (!dialog) return;
    if (variant === 'light') {
      injectClientDataIntoPopup();
      updateLightPopupCartPrice();
      if (!dialog._lightCancelBound) {
        dialog._lightCancelBound = true;
        dialog.addEventListener('cancel', function(e) { e.preventDefault(); });
      }
    }
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');

    if (variant !== 'light') {
      var terms = dialog.querySelector('.upsell-terms__details');
      if (terms) {
        if (window.matchMedia('(max-width: 749px)').matches) terms.setAttribute('open', '');
        else terms.removeAttribute('open');
      }
    }
  }

  /* ===========================
     CHECKOUT PAGE
     =========================== */

  function initCardInputFormatting() {
    // Card number: format as groups of 4 while typing
    var ccNum = document.getElementById('cc-number');
    if (ccNum) {
      ccNum.addEventListener('input', function() {
        var pos = this.selectionStart;
        var raw = this.value.replace(/\D/g, '').slice(0, 16);
        var formatted = raw.replace(/(.{4})/g, '$1 ').trimEnd();
        // Count spaces before cursor in old value to adjust cursor position
        var spacesAdded = (formatted.match(/ /g) || []).length - (this.value.slice(0, pos).match(/ /g) || []).length;
        this.value = formatted;
        var newPos = Math.min(pos + spacesAdded, formatted.length);
        this.setSelectionRange(newPos, newPos);
      });
    }

    // Month: digits only, cap at 12
    var ccMonth = document.getElementById('cc-month');
    if (ccMonth) {
      ccMonth.addEventListener('input', function() {
        var raw = this.value.replace(/\D/g, '').slice(0, 2);
        if (raw.length === 2 && parseInt(raw, 10) > 12) raw = '12';
        if (raw.length === 2 && parseInt(raw, 10) < 1) raw = '01';
        this.value = raw;
      });
    }

    // Year: digits only
    var ccYear = document.getElementById('cc-year');
    if (ccYear) {
      ccYear.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, '').slice(0, 4);
      });
    }

    // CVV: digits only
    var ccCvv = document.getElementById('cc-cvv');
    if (ccCvv) {
      ccCvv.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, '').slice(0, 4);
      });
    }
  }

  function setCheckoutPayEnabled(payBtn, enabled) {
    if (!payBtn) return;
    var termsToggle = document.getElementById('checkout-terms-accepted');
    var accepted = !termsToggle || termsToggle.checked;
    payBtn.disabled = !enabled || !accepted;
    payBtn.setAttribute('aria-disabled', payBtn.disabled ? 'true' : 'false');
  }

  function showCheckoutAlert(message) {
    var existing = document.querySelector('.checkout-alert');
    if (existing) existing.remove();

    var alert = document.createElement('div');
    alert.className = 'checkout-alert';
    alert.setAttribute('role', 'alert');
    alert.textContent = message;
    document.body.appendChild(alert);

    setTimeout(function() {
      alert.classList.add('checkout-alert--leaving');
      alert.addEventListener('animationend', function() { alert.remove(); }, { once: true });
    }, 2600);
  }

  function shakeCheckoutFields(fields) {
    fields.forEach(function(field) {
      if (!field) return;
      field.classList.remove('checkout-field--invalid');
      void field.offsetWidth;
      field.classList.add('checkout-field--invalid');
      field.addEventListener('input', function() {
        field.classList.remove('checkout-field--invalid');
      }, { once: true });
    });

    setTimeout(function() {
      fields.forEach(function(field) {
        if (field) field.classList.remove('checkout-field--invalid');
      });
    }, 900);
  }

  async function initCheckoutPage() {
    if (!document.getElementById('checkout-page-container')) return;

    var browserDataEl = document.getElementById('browserData');
    if (browserDataEl) {
      browserDataEl.value = getBrowserData();
    }

    initCardInputFormatting();

    var urlParams = new URLSearchParams(window.location.search);
    var hasUrlProducts = urlParams.get('products');

    if (hasUrlProducts) {
      await handleAbandonedCart(urlParams);
      return;
    }

    await performPartialAndPixel(urlParams);

    var payBtn = document.getElementById('checkout-pay-btn');
    var termsToggle = document.getElementById('checkout-terms-accepted');
    if (payBtn) {
      if (termsToggle) {
        var syncTermsState = function() {
          var accepted = termsToggle.checked;
          var toggleWrap = termsToggle.closest('.checkout-terms-consent');
          if (toggleWrap) toggleWrap.classList.toggle('checkout-terms-consent--accepted', accepted);
          setCheckoutPayEnabled(payBtn, true);
          if (accepted) {
            var errorEl = document.getElementById('checkout-error');
            if (errorEl && errorEl.textContent === i18n('error_accept_terms')) errorEl.textContent = '';
          }
        };

        syncTermsState();
        termsToggle.addEventListener('change', syncTermsState);
      }

      payBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (termsToggle && !termsToggle.checked) {
          var errorEl = document.getElementById('checkout-error');
          if (errorEl) errorEl.textContent = i18n('error_accept_terms');
          termsToggle.focus();
          return;
        }
        processPayment();
      });
    }
  }

  async function handleAbandonedCart(urlParams) {
    try {
      var productsRaw = urlParams.get('products') || '';
      var products = productsRaw.split(';').filter(Boolean).map(function(p) {
        var parts = p.split(':');
        return { id: parts[0], quantity: parseInt(parts[1]) || 1 };
      });

      var resp = await apiCall(CONFIG.endpoints.abandonedCart, {
        products: products,
        campaignId: urlParams.get('campaignId') || CONFIG.campaignId
      });

      if (resp.status === 'success' && resp.products) {
        // Clear existing cart first
        var currentCart = await getCart();
        for (var i = 0; i < currentCart.items.length; i++) {
          await removeFromCart(currentCart.items[i].variant_id);
        }

        // Add recovered products
        for (var j = 0; j < resp.products.length; j++) {
          var p = resp.products[j];
          await addToCart(parseInt(p.shopify_variant_id), p.quantity);
        }

        var hasSubscriptionProduct = resp.products.some(function(product) {
          return product.shopify_variant_id == CONFIG.subscriptionVariantId;
        });

        // Build attributes from URL
        var attrs = {
          firstName: urlParams.get('firstName') || '',
          lastName: urlParams.get('lastName') || '',
          address1: urlParams.get('address1') || '',
          address2: urlParams.get('address2') || '',
          postalCode: urlParams.get('postalCode') || '',
          city: urlParams.get('city') || '',
          country: urlParams.get('country') || '',
          email: urlParams.get('emailAddress') || '',
          phone: urlParams.get('phoneNumber') || '',
          shipFirstName: urlParams.get('shipFirstName') || urlParams.get('firstName') || '',
          shipLastName: urlParams.get('shipLastName') || urlParams.get('lastName') || '',
          shipAddress1: urlParams.get('shipAddress1') || urlParams.get('address1') || '',
          shipAddress2: urlParams.get('shipAddress2') || urlParams.get('address2') || '',
          shipPostalCode: urlParams.get('shipPostalCode') || urlParams.get('postalCode') || '',
          shipCity: urlParams.get('shipCity') || urlParams.get('city') || '',
          shipCountry: urlParams.get('shipCountry') || urlParams.get('country') || ''
        };

        await updateCartAttributes(attrs);

        // Store load-balancing & pixel data
        var hasSubParam = urlParams.get('has_subscription') || (hasSubscriptionProduct ? '1' : '0');
        setStoredParam('has_subscription', hasSubParam);
        setStoredParam('forceMerchantId', urlParams.get('forceMerchantId') || '');
        setStoredParam('originalCampaignId', urlParams.get('campaignId') || CONFIG.campaignId);
        setStoredParam('shipProfileId', urlParams.get('shipProfileId') || CONFIG.shipProfileId);
        setStoredParam('pixels', urlParams.get('pixel') || '');

        // If has_subscription=1 from URL, remove subscription product from cart to avoid double subscription
        if (hasSubParam === '1' && hasSubscriptionProduct) {
          await removeFromCart(CONFIG.subscriptionVariantId);
        }

        goToSecureDesk();
      }
    } catch(err) {
      console.error('Abandoned cart error:', err);
    }
  }

  async function performPartialAndPixel(urlParams) {
    try {
      var ip = await getClientIp();
      var metaData = await getCartMetadata();
      var cart = await getCart();

      var hasAboInCart = cart.items.some(function(it) { return it.variant_id == CONFIG.subscriptionVariantId; });
      var partialAttrs = cart.attributes || {};
      var hasSubBenefit = hasAboInCart || getStoredParam('has_subscription') === '1' || hasActiveSubscription() || partialAttrs.has_subscription === '1';
      var productsStr = buildProductsString(metaData, hasSubBenefit);

      var attrs = partialAttrs;
      var originalCampaignId = getStoredParam('originalCampaignId') || CONFIG.campaignId;

      var partialData = {
        products: productsStr,
        cartId: cart.token || '',
        firstName: attrs.firstName || '',
        lastName: attrs.lastName || '',
        address1: attrs.address1 || '',
        address2: attrs.address2 || '',
        postalCode: attrs.postalCode || '',
        city: attrs.city || '',
        country: attrs.country || '',
        adresseMail: attrs.email || '',
        phoneNumber: attrs.phone || '',
        ipAddress: ip,
        shipFirstName: attrs.shipFirstName || attrs.firstName || '',
        shipLastName: attrs.shipLastName || attrs.lastName || '',
        shipAddress1: attrs.shipAddress1 || attrs.address1 || '',
        shipAddress2: attrs.shipAddress2 || attrs.address2 || '',
        shipPostalCode: attrs.shipPostalCode || attrs.postalCode || '',
        shipCity: attrs.shipCity || attrs.city || '',
        shipCountry: attrs.shipCountry || attrs.country || '',
        billShipSame: '1',
        custom1: buildCustom1HostWithLocale(),
        custom2: 'checkout',
        custom3: CONFIG.slugThankYou,
        custom4: '',
        custom5: '',
        campaignId: CONFIG.campaignId,
        originalCampaignId: originalCampaignId,
        checkoutUrl: window.location.href
      };

      await apiCall(CONFIG.endpoints.sendPartial, partialData);
    } catch(err) {
      console.error('Partial/pixel error:', err);
    }
  }

  /* ─────────────────────────────────────────────────────────────
     ADDRESS SUGGESTION MODAL
     Shown when shopper_lookup returns showSuggestions:true
     ───────────────────────────────────────────────────────────── */
  /* ─────────────────────────────────────────────────────────────
     ADDRESS ERROR HELPERS
     ───────────────────────────────────────────────────────────── */

  // Map API error keys → cart form field IDs
  var _ADDR_FIELD_MAP = {
    emailAddress:       'shipping_email',
    shippingFirstName:  'shipping_firstname',
    shippingLastName:   'shipping_lastname',
    shippingAddress1:   'shipping_address1',
    shippingAddress2:   'shipping_address2',
    shippingPostalCode: 'shipping_postal',
    shippingCity:       'shipping_city',
    shippingCountry:    'shipping_country',
    phone:              'shipping_phone'
  };

  // Build a human-readable message from the API response and highlight bad fields
  function applyAddrErrors(addrResp, errorEl) {
    var errors = addrResp.errors;
    var msg;

    var getAddressErrorFallbackKey = function(fieldKey) {
      return fieldKey === 'phone' ? 'error_phone_invalid' : 'error_address_invalid';
    };

    var localizeAddressError = function(fieldKey, apiMessage) {
      var fallback = i18n(getAddressErrorFallbackKey(fieldKey));
      var normalizedMessage = normalizeApiMessage(apiMessage).trim();
      if (!normalizedMessage) return fallback;

      // Backend validation may return French by default. Outside FR locales,
      // prefer locale-aware UI strings instead of raw backend messages.
      if (getActiveLocale().indexOf('fr') === 0) return normalizedMessage;
      return fallback;
    };

    if (errors && typeof errors === 'object' && Object.keys(errors).length) {
      var messages = [];
      // Highlight each offending field in the cart form
      Object.keys(errors).forEach(function(key) {
        var localized = localizeAddressError(key, errors[key]);
        if (localized && messages.indexOf(localized) === -1) {
          messages.push(localized);
        }
        var fieldId = _ADDR_FIELD_MAP[key];
        if (fieldId) {
          var el = document.getElementById(fieldId);
          if (el) el.classList.add('field--error');
        }
      });
      msg = messages.join(' - ') || i18n('error_address_invalid');
    } else {
      msg = localizeAddressError('', addrResp.message);
    }

    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    return msg;
  }

  // onConfirm: called after user picks a suggestion or clicks skip.
  // Defaults to processPayment(true) when on checkout page.
  function showAddressSuggestions(suggestions, onConfirm) {
    var existing = document.getElementById('addr-suggestions-modal');
    if (existing) { existing.close(); existing.remove(); }

    // Use a native <dialog> + showModal() so it enters the browser top layer
    // and always renders above other dialogs (e.g. the cart drawer).
    var overlay = document.createElement('dialog');
    overlay.id = 'addr-suggestions-modal';
    overlay.className = 'addr-modal';

    var listHtml = suggestions.map(function(s, idx) {
      var label = s.formatted || [s.street, (s.postcode || '') + ' ' + (s.city || ''), s.country].filter(Boolean).join(', ');
      return '<li>' +
        '<button class="addr-modal__option" data-idx="' + idx + '" type="button">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>' +
          '<span>' + label + '</span>' +
        '</button>' +
      '</li>';
    }).join('');

    overlay.innerHTML =
      '<div class="addr-modal__box">' +
        '<button class="addr-modal__close" id="addr-modal-close" type="button" aria-label="' + i18n('sub_modal_close_aria') + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="addr-modal__icon" aria-hidden="true">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        '</div>' +
        '<h3 class="addr-modal__title">' + i18n('address_suggestion_title') + '</h3>' +
        '<p class="addr-modal__sub">' + i18n('address_suggestion_sub') + '</p>' +
        '<ul class="addr-modal__list">' + listHtml + '</ul>' +
        '<button class="addr-modal__skip" type="button">' + i18n('address_suggestion_skip') + '</button>' +
      '</div>';

    document.body.appendChild(overlay);
    overlay.showModal();

    function closeModal() {
      overlay.close();
      overlay.remove();
    }

    // Close (no action, user must pick or skip)
    overlay.querySelector('#addr-modal-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    // Skip → proceed with original address, bypass addr check
    overlay.querySelector('.addr-modal__skip').addEventListener('click', function() {
      closeModal();
      if (typeof onConfirm === 'function') { onConfirm(); } else { processPayment(true); }
    });

    // Select a suggestion → update cart attributes then proceed
    overlay.querySelectorAll('.addr-modal__option').forEach(function(optBtn) {
      optBtn.addEventListener('click', async function() {
        var s = suggestions[parseInt(optBtn.dataset.idx)];
        var update = {};
        if (s.street)   update.address1  = s.street;
        if (s.building) update.address2  = s.building;
        if (s.postcode) update.postalCode = s.postcode;
        if (s.city)     update.city       = s.city;
        if (s.country)  update.country    = s.country;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: update })
          });
        } catch(e) {}
        closeModal();
        if (typeof onConfirm === 'function') { onConfirm(); } else { processPayment(true); }
      });
    });

    requestAnimationFrame(function() {
      var close = overlay.querySelector('#addr-modal-close');
      if (close) close.focus();
    });
  }

  async function processPayment(skipAddrCheck) {
    var payBtn = document.getElementById('checkout-pay-btn');
    var errorEl = document.getElementById('checkout-error');
    var termsToggle = document.getElementById('checkout-terms-accepted');

    if (termsToggle && !termsToggle.checked) {
      if (errorEl) errorEl.textContent = i18n('error_accept_terms');
      termsToggle.focus();
      return;
    }

    // Validate card
    var cardNumber = document.getElementById('cc-number');
    var cardMonth = document.getElementById('cc-month');
    var cardYear = document.getElementById('cc-year');
    var cardCvv = document.getElementById('cc-cvv');

    var missingPaymentFields = [cardNumber, cardMonth, cardYear, cardCvv].filter(function(field) {
      return !field || !field.value;
    });

    if (missingPaymentFields.length) {
      if (errorEl) errorEl.textContent = '';
      shakeCheckoutFields(missingPaymentFields);
      showCheckoutAlert(i18n('error_fill_payment'));
      if (missingPaymentFields[0]) missingPaymentFields[0].focus();
      return;
    }

    payBtn.disabled = true;
    payBtn.setAttribute('aria-disabled', 'true');
    payBtn.classList.add('loading');
    if (errorEl) errorEl.textContent = '';

    try {
      // ── Address verification via shopper_lookup ──
      var cart = await getCart();

      var addrEndpoint = CONFIG.endpoints.shopperLookup || 'shopper_lookup.php';
      if (!skipAddrCheck && addrEndpoint) {
        var attrs0 = cart.attributes || {};
        if (errorEl) errorEl.textContent = '';
        try {
          var addrResp = await apiCall(addrEndpoint, {
            emailAddress:      attrs0.email        || '',
            shippingFirstName: attrs0.firstName    || '',
            shippingLastName:  attrs0.lastName     || '',
            shippingAddress1:  attrs0.address1     || '',
            shippingAddress2:  attrs0.address2     || '',
            shippingPostalCode:attrs0.postalCode   || '',
            shippingCity:      attrs0.city         || '',
            shippingCountry:   attrs0.country      || '',
            phone:             attrs0.phone        || '',
            sessionId:         cart.token          || '',
            isF:               false,
            language:          getActiveLocale() || 'fr'
          });
          if (errorEl) errorEl.textContent = '';

          if (addrResp.success === false) {
            setCheckoutPayEnabled(payBtn, true);
            payBtn.classList.remove('loading');
            if (addrResp.showSuggestions && addrResp.addressSuggestions && addrResp.addressSuggestions.length) {
              showAddressSuggestions(addrResp.addressSuggestions);
            } else {
              applyAddrErrors(addrResp, errorEl);
            }
            return;
          }
        } catch(addrErr) {
          // API unreachable or returned non-JSON → allow payment to proceed
          if (errorEl) errorEl.textContent = '';
        }
      }
      // ── End address verification ──

      var ip = await getClientIp();
      var metaData = await getCartMetadata();
      // cart already fetched above

      // Facebook AddPaymentInfo
      var pixelConfigs = resolvePixelConfigs();
      if (pixelConfigs.length) {
        var totalForPixel = 0;
        cart.items.forEach(function(it) { totalForPixel += it.final_line_price; });
        await sendFacebookEvent('AddPaymentInfo', pixelConfigs,
          { ip: ip, email: (cart.attributes || {}).email || '' },
          { value: totalForPixel / 100 });
      }

      var hasAboInCart = cart.items.some(function(it) { return it.variant_id == CONFIG.subscriptionVariantId; });
      var cartAttrs = cart.attributes || {};
      var hasSubBenefit = hasAboInCart || getStoredParam('has_subscription') === '1' || hasActiveSubscription() || cartAttrs.has_subscription === '1';
      var productsStr = buildProductsString(metaData, hasSubBenefit);

      var subtotalCents = 0;
      cart.items.forEach(function(it) {
        if (it.variant_id != CONFIG.subscriptionVariantId) {
          subtotalCents += it.final_line_price;
        }
      });
      var chargeTotal;
      if (hasSubBenefit) {
        chargeTotal = (subtotalCents / 100).toFixed(2);
      } else {
        chargeTotal = ((subtotalCents + CONFIG.shipPrice) / 100).toFixed(2);
      }

      var attrs = cart.attributes || {};
      var originalCampaignId = getStoredParam('originalCampaignId') || CONFIG.campaignId;
      var forceMerchantId = getStoredParam('forceMerchantId') || '';
      var shipProfileId = getStoredParam('shipProfileId') || CONFIG.shipProfileId;

      var thankYouUrl = buildApiUrl(CONFIG.endpoints.thankYouRedirect);
      var checkoutUrl = window.location.href;

      var nowMs = Date.now();
      var emailVal = attrs.email || '';

      var orderData = {
        products: productsStr,
        chargeTotal: chargeTotal,
        amount: chargeTotal,
        totalAmount: chargeTotal,
        cartId: cart.token || '',
        cartToken: cart.token || '',
        cart_id: cart.token || '',
        firstName: attrs.firstName || '',
        lastName: attrs.lastName || '',
        address1: attrs.address1 || '',
        address2: attrs.address2 || '',
        postalCode: attrs.postalCode || '',
        city: attrs.city || '',
        country: attrs.country || '',
        adresseMail: emailVal,
        mail: emailVal,
        userEmail: emailVal,
        phoneNumber: attrs.phone || '',
        ipAddress: ip,
        shipFirstName: attrs.shipFirstName || attrs.firstName || '',
        shipLastName: attrs.shipLastName || attrs.lastName || '',
        shipAddress1: attrs.shipAddress1 || attrs.address1 || '',
        shipAddress2: attrs.shipAddress2 || attrs.address2 || '',
        shipPostalCode: attrs.shipPostalCode || attrs.postalCode || '',
        shipCity: attrs.shipCity || attrs.city || '',
        shipCountry: attrs.shipCountry || attrs.country || '',
        billShipSame: '1',
        cardNumber: cardNumber.value.replace(/\s/g, ''),
        cardMonth: cardMonth.value,
        cardYear: cardYear.value,
        cardSecurityCode: cardCvv.value,
        paySource: 'CREDITCARD',
        browserData: document.getElementById('browserData') ? document.getElementById('browserData').value : getBrowserData(),
        redirectsTo: thankYouUrl,
        errorRedirectsTo: checkoutUrl,
        hostname: window.location.hostname,
        siteName: window.location.hostname,
        custom1: buildCustom1HostWithLocale(),
        custom2: 'checkout',
        custom3: CONFIG.slugThankYou,
        custom4: '',
        custom5: '',
        lang: getActiveLocale() || 'fr',
        language: getActiveLocale() || 'fr',
        campaignId: CONFIG.campaignId,
        originalCampaignId: originalCampaignId,
        dateTime: nowMs,
        createdAt: nowMs
      };

      if (forceMerchantId) {
        orderData.forceMerchantId = forceMerchantId;
      }

      if (hasSubBenefit) {
        orderData.couponCode = 'FREEDEL';
      } else {
        orderData.shipProfileId = shipProfileId;
      }

      var resp = await apiCall(CONFIG.endpoints.sendOrder, orderData);

      switch (resp.result) {
        case 'SUCCESS':
          var redirectUrl = thankYouUrl + '?orderData=' + encodeURIComponent(JSON.stringify(resp.message));
          window.location.href = redirectUrl;
          break;

        case 'ERROR':
          if (errorEl) errorEl.textContent = resp.message || i18n('error_payment');
          setCheckoutPayEnabled(payBtn, true);
          payBtn.classList.remove('loading');
          break;

        case 'MERC_REDIRECT':
          // Sauvegarder les données client avant la redirection 3DS
          // confirmation_gateway.php ne reçoit pas toujours tous les champs de CC
          try {
            sessionStorage.setItem('cc_pending_order', JSON.stringify({
              email:          orderData.emailAddress || orderData.email || orderData.adresseMail || '',
              phoneNumber:    orderData.phoneNumber  || orderData.phone || '',
              totalAmount:    orderData.chargeTotal  || orderData.totalAmount || orderData.amount || '0.00',
              currencySymbol: orderData.currencySymbol || '€',
              firstName:      orderData.firstName    || '',
              lastName:       orderData.lastName     || '',
              address1:       orderData.address1     || '',
              address2:       orderData.address2     || '',
              city:           orderData.city         || '',
              postalCode:     orderData.postalCode   || '',
              country:        orderData.country      || '',
              shipFirstName:  orderData.shipFirstName  || orderData.firstName  || '',
              shipLastName:   orderData.shipLastName   || orderData.lastName   || '',
              shipAddress1:   orderData.shipAddress1   || orderData.address1   || '',
              shipAddress2:   orderData.shipAddress2   || orderData.address2   || '',
              shipCity:       orderData.shipCity       || orderData.city       || '',
              shipPostalCode: orderData.shipPostalCode || orderData.postalCode || '',
              shipCountry:    orderData.shipCountry    || orderData.country    || ''
            }));
          } catch(e) {}
          if (resp.message && resp.message.url) {
            window.location.href = resp.message.url;
          } else if (resp.message && resp.message.script) {
            eval(resp.message.script);
          }
          break;

        default:
          console.error('Unknown response:', resp);
          if (errorEl) errorEl.textContent = (resp && resp.success === false && resp.message) ? resp.message : i18n('error_unexpected');
          setCheckoutPayEnabled(payBtn, true);
          payBtn.classList.remove('loading');
      }
    } catch(err) {
      console.error('Payment error:', err);
      if (errorEl) errorEl.textContent = i18n('error_server');
      setCheckoutPayEnabled(payBtn, true);
      payBtn.classList.remove('loading');
    }
  }

  /* ===========================
     THANK YOU PAGE
     =========================== */

  async function initThankYouPage() {
    if (!document.getElementById('thankyou-page-container')) return;

    var urlParams = new URLSearchParams(window.location.search);

    var orderInfo = {
      orderId: urlParams.get('orderId') || '',
      email: urlParams.get('email') || '',
      totalAmount: urlParams.get('totalAmount') || '0.00',
      currencySymbol: urlParams.get('currencySymbol') || '€',
      firstName: urlParams.get('firstName') || '',
      lastName: urlParams.get('lastName') || '',
      address1: urlParams.get('address1') || '',
      address2: urlParams.get('address2') || '',
      city: urlParams.get('city') || '',
      postalCode: urlParams.get('postalCode') || '',
      country: urlParams.get('country') || '',
      shipFirstName: urlParams.get('shipFirstName') || '',
      shipLastName: urlParams.get('shipLastName') || '',
      shipAddress1: urlParams.get('shipAddress1') || '',
      shipAddress2: urlParams.get('shipAddress2') || '',
      shipCity: urlParams.get('shipCity') || '',
      shipPostalCode: urlParams.get('shipPostalCode') || '',
      shipCountry: urlParams.get('shipCountry') || '',
      currencyCode: urlParams.get('currencyCode') || ''
    };

    setTextIfExists('ty-order-id', orderInfo.orderId);
    setTextIfExists('ty-email', orderInfo.email);
    setTextIfExists('ty-total', orderInfo.currencySymbol + orderInfo.totalAmount);
    setTextIfExists('ty-name', orderInfo.firstName + ' ' + orderInfo.lastName);
    setTextIfExists('ty-address', orderInfo.shipAddress1 + (orderInfo.shipAddress2 ? ', ' + orderInfo.shipAddress2 : ''));
    setTextIfExists('ty-city', orderInfo.shipPostalCode + ' ' + orderInfo.shipCity);
    setTextIfExists('ty-country', orderInfo.shipCountry);

    // Facebook Purchase pixel (once per order — thank-you refresh must not duplicate)
    var pixelConfigs = resolvePixelConfigs();
    var purchaseKey = orderInfo.orderId ? 'tinker_purchase_sent_' + orderInfo.orderId : '';
    var alreadySent = false;
    try { alreadySent = !!(purchaseKey && sessionStorage.getItem(purchaseKey)); } catch (e) {}
    if (pixelConfigs.length && !alreadySent) {
      try {
        var ip = await getClientIp();
        await sendFacebookEvent('Purchase', pixelConfigs,
          { ip: ip, email: orderInfo.email },
          { value: parseFloat(orderInfo.totalAmount) || 0 });
        if (purchaseKey) { try { sessionStorage.setItem(purchaseKey, '1'); } catch (e) {} }
      } catch(e) {}
      setStoredParam('pixels', '');
    }

    // Clear cart and notify theme components to update counts/drawer immediately
    try {
      var clearedCart = await fetch('/cart/clear.js', { method: 'POST' }).then(function(r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: clearedCart, data: { itemCount: 0 } }
      }));
      // Also update any visible cart count badges directly
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble, .header__cart-count').forEach(function(el) {
        el.textContent = '0';
        el.setAttribute('data-count', '0');
        if (el.dataset.cartCount !== undefined) el.dataset.cartCount = '0';
      });
    } catch(e) {}
  }

  /* ===========================
     SUBSCRIPTION CART GUARD
     =========================== */

  function ensureSubModalStyles() {
    if (document.getElementById('sub-modal-styles')) return;
    var s = document.createElement('style');
    s.id = 'sub-modal-styles';
    s.textContent = [
      '#sub-active-modal{',
        'border:none;padding:0;background:transparent;',
        'max-width:100vw;max-height:100vh;',
        'position:fixed;inset:0;z-index:10000;',
        'width:100%;height:100%;',
        'overflow:visible;',
      '}',
      '#sub-active-modal[open]{',
        'display:flex;align-items:center;justify-content:center;',
      '}',
      '#sub-active-modal::backdrop{',
        'background:rgba(0,0,0,0.5);',
        'backdrop-filter:blur(3px);',
      '}',
      '.sub-modal__box{',
        'background:var(--color-background,#fff);',
        'color:var(--color-foreground,#111);',
        'font-family:var(--font-body--family,sans-serif);',
        'border-radius:16px;',
        'padding:40px 36px 36px;',
        'max-width:440px;width:calc(100vw - 40px);',
        'position:relative;',
        'text-align:center;',
        'box-shadow:0 20px 60px rgba(0,0,0,0.2);',
        'animation:subModalIn 0.3s cubic-bezier(0.34,1.56,0.64,1) both;',
      '}',
      '@keyframes subModalIn{',
        'from{opacity:0;transform:scale(0.88) translateY(12px)}',
        'to{opacity:1;transform:scale(1) translateY(0)}',
      '}',
      '.sub-modal__close{',
        'position:absolute;top:14px;right:14px;',
        'background:none;border:none;cursor:pointer;',
        'color:var(--color-foreground-muted,#999);',
        'padding:4px;line-height:1;font-size:20px;',
        'transition:color 0.2s;',
      '}',
      '.sub-modal__close:hover{color:var(--color-foreground,#111);}',
      '.sub-modal__icon{',
        'width:56px;height:56px;border-radius:50%;',
        'background:var(--color-primary,#0a0a0a);',
        'color:var(--color-primary-contrast,#fff);',
        'display:flex;align-items:center;justify-content:center;',
        'margin:0 auto 20px;font-size:22px;',
      '}',
      '.sub-modal__title{',
        'font-family:var(--font-heading--family,serif);',
        'font-size:clamp(1.25rem,4vw,1.5rem);',
        'font-weight:var(--font-heading--weight,700);',
        'letter-spacing:var(--font-heading--letter-spacing,0);',
        'margin:0 0 10px;line-height:1.25;',
      '}',
      '.sub-modal__subtitle{',
        'font-size:0.9rem;',
        'color:var(--color-foreground-muted,#666);',
        'margin:0 0 22px;line-height:1.55;',
      '}',
      '.sub-modal__perks{',
        'list-style:none;padding:0;margin:0 0 28px;',
        'display:flex;flex-direction:column;gap:10px;',
        'text-align:left;',
      '}',
      '.sub-modal__perks li{',
        'display:flex;align-items:center;gap:10px;',
        'font-size:0.875rem;font-weight:500;',
      '}',
      '.sub-modal__perk-icon{',
        'flex-shrink:0;width:20px;height:20px;border-radius:50%;',
        'background:var(--color-primary,#0a0a0a);',
        'color:var(--color-primary-contrast,#fff);',
        'display:flex;align-items:center;justify-content:center;',
        'font-size:10px;',
      '}',
      '.sub-modal__cta{',
        'width:100%;padding:14px 20px;',
        'background:var(--color-primary,#0a0a0a);',
        'color:var(--color-primary-contrast,#fff);',
        'border:none;border-radius:8px;cursor:pointer;',
        'font-family:var(--font-body--family,sans-serif);',
        'font-size:0.9375rem;font-weight:600;letter-spacing:0.02em;',
        'transition:opacity 0.2s;',
      '}',
      '.sub-modal__cta:hover{opacity:0.85;}',
      '.sub-modal__account-link{',
        'display:block;margin-top:12px;',
        'font-size:0.8rem;',
        'color:var(--color-foreground-muted,#888);',
        'text-decoration:underline;text-underline-offset:3px;',
        'cursor:pointer;transition:color 0.2s;',
      '}',
      '.sub-modal__account-link:hover{color:var(--color-foreground,#111);}'
    ].join('');
    document.head.appendChild(s);
  }

  function showActiveSubscriptionModal() {
    ensureSubModalStyles();

    var existing = document.getElementById('sub-active-modal');
    if (existing) { existing.showModal(); return; }

    var perkCheck = '<span class="sub-modal__perk-icon" aria-hidden="true">' +
      '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="2 6 5 9 10 3"/></svg></span>';

    var dialog = document.createElement('dialog');
    dialog.id = 'sub-active-modal';
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'sub-modal-title');
    dialog.innerHTML =
      '<div class="sub-modal__box">' +
        '<button class="sub-modal__close" aria-label="' + i18n('sub_modal_close_aria') + '" id="sub-modal-close-btn">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="sub-modal__icon" aria-hidden="true">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</div>' +
        '<h2 class="sub-modal__title" id="sub-modal-title">' + i18n('sub_modal_title') + '</h2>' +
        '<p class="sub-modal__subtitle">' + i18n('sub_modal_subtitle') + '</p>' +
        '<ul class="sub-modal__perks">' +
          '<li>' + perkCheck + '<span>' + i18n('sub_modal_perk_discount') + '</span></li>' +
          '<li>' + perkCheck + '<span>' + i18n('sub_modal_perk_shipping') + '</span></li>' +
          '<li>' + perkCheck + '<span>' + i18n('sub_modal_perk_library') + '</span></li>' +
          '<li>' + perkCheck + '<span>' + i18n('sub_modal_perk_warranty') + '</span></li>' +
        '</ul>' +
        '<button class="sub-modal__cta" id="sub-modal-cta">' + i18n('sub_modal_continue_shopping') + '</button>' +
        '<a class="sub-modal__account-link" id="sub-modal-account-link" href="' + getLocalePrefix() + '/pages/' + CONFIG.slugAccount + '">' + i18n('sub_modal_go_to_account') + '</a>' +
      '</div>';

    document.body.appendChild(dialog);

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });

    var closeBtn = dialog.querySelector('#sub-modal-close-btn');
    var cta = dialog.querySelector('#sub-modal-cta');
    if (closeBtn) closeBtn.addEventListener('click', function() { dialog.close(); });
    if (cta) cta.addEventListener('click', function() { dialog.close(); });

    dialog.showModal();
  }

  function showSubToast(message) {
    var existing = document.getElementById('sub-cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'sub-cart-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
      '<span>' + message + '</span>';

    var style = toast.style;
    style.cssText = [
      'position:fixed',
      'top:20px',
      'left:50%',
      'transform:translateX(-50%) translateY(-12px)',
      'display:flex',
      'align-items:center',
      'gap:10px',
      'background:var(--color-foreground,#111)',
      'color:var(--color-background,#fff)',
      'font-family:var(--font-body--family,sans-serif)',
      'font-size:0.875rem',
      'line-height:1.4',
      'padding:12px 18px',
      'border-radius:10px',
      'box-shadow:0 4px 20px rgba(0,0,0,0.18)',
      'z-index:9999',
      'opacity:0',
      'transition:opacity 0.25s ease,transform 0.25s ease',
      'max-width:calc(100vw - 40px)',
      'pointer-events:none'
    ].join(';');

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
      });
    });

    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(-12px)';
      setTimeout(function() { if (toast.parentNode) toast.remove(); }, 300);
    }, 4000);
  }

  function initSubscriptionCartGuard() {
    var subId = CONFIG.subscriptionVariantId;
    if (!subId) return;

    // The actual decision logic. The early inline script in theme.liquid
    // intercepts the submit event first (before component.js) and dispatches
    // this custom event so we can decide here without a race condition.
    document.addEventListener('sub:guard-check', function(e) {
      var form = e.target;
      if (!form) return;

      // Logged-in subscriber trying to buy again → show informational modal
      if (hasActiveSubscription() || getStoredParam('has_subscription') === '1') {
        showActiveSubscriptionModal();
        return;
      }

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var alreadyInCart = cart.items.some(function(item) {
            return item.variant_id === subId;
          });

          if (alreadyInCart) {
            showSubToast(i18n('subscription_already_in_cart'));
          } else {
            // Not in cart — directly invoke the product-form-component's handler
            // so the add bypasses the guard interception entirely
            var productForm = form.closest('product-form-component');
            if (productForm && typeof productForm.handleSubmit === 'function') {
              productForm.handleSubmit(new Event('submit', { cancelable: true }));
            }
          }
        })
        .catch(function() {
          var productForm = form.closest('product-form-component');
          if (productForm && typeof productForm.handleSubmit === 'function') {
            productForm.handleSubmit(new Event('submit', { cancelable: true }));
          }
        });
    });
  }

  /* ===========================
     INITIALIZATION
     =========================== */

  document.addEventListener('DOMContentLoaded', function() {
    initCancelSubscription();
    initSubscriptionCartGuard();
    initSubscriptionCheckPrewarm();
    initAddrCheckPrewarm();
    initAccountPage();
    initAccountLogin();
    initAccountLogout();
    initAccountPopupClose();
    initShippingForm();
    initCheckoutIntercept();
    bindUpsellModals();
    initCheckoutPage();
    initThankYouPage();
    initFacebookAddToCart();
  });

})();
